<template>
<div>
    <nav class="navbar navbar-expand-lg navbar-dark navbar-scrolled">
        <div class="container">
            <router-link class="navbar-brand navbar-brand-shimmer" :to="{path: '/'}">{{ $state.siteName }}</router-link>
            <button class="navbar-toggler" type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarCollapse"
                    aria-controls="navbarCollapse"
                    aria-expanded="false"
                    aria-label="Menu">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarCollapse">
                <button class="navbar-toggler" type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarCollapse"
                        aria-controls="navbarCollapse"
                        aria-expanded="false"
                        aria-label="Menu">
                    <i class="fe fe-x"></i>
                </button>
                <ul class="navbar-nav ms-auto">
                    <li class="nav-item">
                        <router-link :to="{path: '/dashboard'}" class="nav-link" exact-active-class="active">Dashboard</router-link>
                    </li>
                    <li class="nav-item dropdown" :class="{ show: productsDropdownOpen }">
                        <a class="nav-link dropdown-toggle" id="navbarProducts"
                           href="#" aria-haspopup="true" :aria-expanded="productsDropdownOpen"
                           @click.prevent="productsDropdownOpen = !productsDropdownOpen">
                            Products
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-left: 2px; vertical-align: middle;"><polyline points="6 9 12 15 18 9"></polyline></svg>
                        </a>
                        <div class="dropdown-menu dropdown-menu-md" :class="{ show: productsDropdownOpen }" aria-labelledby="navbarProducts">
                            <div class="list-group list-group-flush">
                                <router-link :to="{path: '/cache-api'}" class="list-group-item">
                                    <div class="icon icon-sm text-primary">
                                        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path d="M5 2h14a2 2 0 012 2v2a2 2 0 01-2 2H5a2 2 0 01-2-2V4a2 2 0 012-2zm6 2a1 1 0 000 2h5a1 1 0 000-2h-5zM7 6a1 1 0 100-2 1 1 0 000 2z" fill="#335EEA" opacity=".3"/><path d="M5 9h14a2 2 0 012 2v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-2a2 2 0 012-2zm6 2a1 1 0 000 2h5a1 1 0 000-2h-5zm-4 2a1 1 0 100-2 1 1 0 000 2zM5 16h14a2 2 0 012 2v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-2a2 2 0 012-2zm6 2a1 1 0 000 2h5a1 1 0 000-2h-5zm-4 2a1 1 0 100-2 1 1 0 000 2z" fill="#335EEA"/></g></svg>
                                    </div>
                                    <div class="ms-4">
                                        <h6 class="fw-bold text-uppercase text-primary mb-0">Cache API</h6>
                                        <p class="fs-sm text-gray-700 mb-0">Access cached Instagram data</p>
                                    </div>
                                </router-link>
                                <router-link :to="{path: '/datasets'}" class="list-group-item">
                                    <div class="icon icon-sm text-primary">
                                        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path d="M4 9.675l6.88 3.972a.89.89 0 00.231.093v7.704l-6.62-3.918a1 1 0 01-.491-.86V9.675zm16-.106v7.097a1 1 0 01-.49.86l-6.621 3.918v-7.771a.903.903 0 00.048-.026L20 9.569z" fill="#335EEA"/><path d="M4.216 7.747a.999.999 0 01.314-.262l7-3.728a1 1 0 01.94 0l7 3.728c.095.05.18.116.253.191l-7.675 4.431a.893.893 0 00-.14.1.893.893 0 00-.139-.1l-7.553-4.36z" fill="#335EEA" opacity=".3"/></g></svg>
                                    </div>
                                    <div class="ms-4">
                                        <h6 class="fw-bold text-uppercase text-primary mb-0">Datasets</h6>
                                        <p class="fs-sm text-gray-700 mb-0">Download ready-made datasets</p>
                                    </div>
                                </router-link>
                                <router-link :to="{path: '/mcp'}" class="list-group-item">
                                    <div class="icon icon-sm text-primary">
                                        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path d="M19 11h1a3 3 0 010 6h-1v3a2 2 0 01-2 2H5a2 2 0 01-2-2v-3h2a3 3 0 000-6H3V8a2 2 0 012-2h3V5a3 3 0 116 0v1h3a2 2 0 012 2v3z" fill="#335EEA" opacity=".3"/></g></svg>
                                    </div>
                                    <div class="ms-4">
                                        <h6 class="fw-bold text-uppercase text-primary mb-0">MCP</h6>
                                        <p class="fs-sm text-gray-700 mb-0">Model Context Protocol</p>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{path: '/tokens'}" class="nav-link">Tokens</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{path: '/affiliate'}" class="nav-link">Affiliate</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{path: '/plan'}" class="nav-link">Plan</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{path: '/billing'}" class="nav-link">Billing</router-link>
                    </li>
                </ul>
                <router-link :to="{path: '/logout'}" class="navbar-btn btn btn-sm btn-primary lift ms-auto" v-if="$state.context.id">
                    Logout
                </router-link>
                <router-link :to="{path: '/login'}" class="navbar-btn btn btn-sm btn-primary lift ms-auto" v-else>
                    Login
                </router-link>
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <div class="avatar avatar-lg" style="margin-left:10px">
                            <router-link :to="{path: '/settings'}">
                                <img :src="`https://www.gravatar.com/avatar/${$state.context.gravatar_hash}`" class="avatar-img rounded-circle">
                            </router-link>
                        </div>
                     </li>
                </ul>
            </div>
        </div>
    </nav>
    <main>
        <section v-if="$state.context.is_unverified_trial" class="pt-4">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="alert alert-success" role="alert">
                            <p>
                                To activate the trial you need to confirm your Telegram ID through our bot by <a :href="`${$state.siteTgBase}/${$state.context.tg_bot}?start=${$state.context.token}`">the link</a>
                            </p>
                            <div>
                                <h5>Enjoying our service? Share your experience!</h5>
                                <ul>
                                    <li>
                                        📝 {{ reviewPlatform.prompt }}
                                        <a :href="reviewPlatform.url" target="_blank">
                                          {{ reviewPlatform.name }}
                                        </a>
                                        {{ reviewPlatform.suffix }}
                                    </li>
                                    <li v-for="detail in (reviewPlatform.details || [])" :key="detail">{{ detail }}</li>
                                    <li v-if="reviewPlatform.cta" v-html="'💬 ' + reviewPlatform.cta"></li>
                                    <template v-if="!reviewPlatform.details">
                                        <li>🧠 A few words about your experience go a long way</li>
                                        <li>💬 Let us know at <a :href="`${$state.siteTgBase}/${$state.siteTgSupport}`">@{{ $state.siteTgSupport }}</a> once you've shared your thoughts — we have a little something for active users 😉</li>
                                    </template>
                                </ul>
                                <p v-if="reviewPlatform.footer" class="mb-0 mt-2" style="font-size: 0.9em;">
                                    🤝 {{ reviewPlatform.footer }}
                                </p>
                                <p class="mb-0 mt-2" style="font-size: 0.9em;">
                                    Had a bad experience? Let us know at
                                    <a :href="`${$state.siteTgBase}/${$state.siteTgSupport}`">@{{ $state.siteTgSupport }}</a> or
                                    <a :href="`mailto:${$state.siteEmail}`">{{ $state.siteEmail }}</a>
                                    — we'd love to fix it!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <router-view></router-view>
    </main>
    <footer class="py-8 py-md-11 border-top border-secondary">
        <Footer />
    </footer>
</div>
</template>
<script>
import { EventBus } from "@/bus"
import Footer from './Footer.vue'
export default {
    components: { Footer },
    data() {
        return {
            productsDropdownOpen: false
        }
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside)
    },
    created() {
        EventBus.on("context:loaded", this.checkLogin)
        if (this.$state.context.loaded) {
            this.checkLogin(this.$state.context)
        } else {
            EventBus.emit("context:request")
        }
    },
    beforeUnmount() {
        EventBus.off("context:loaded", this.checkLogin)
        document.removeEventListener('click', this.handleClickOutside)
    },
    watch: {
        $route() {
            this.checkLogin(this.$state.context)
        }
    },
    computed: {
        reviewPlatforms() {
            const domain = this.$state.siteDomain
            const site = this.$state.siteName
            const tg = this.$state.siteTgSupport
            const tgBase = this.$state.siteTgBase
            return [
                {
                    name: 'Trustpilot',
                    prompt: 'Leave an honest review on',
                    suffix: 'from a verified account',
                    url: `https://www.trustpilot.com/review/${domain}`,
                },
                {
                    name: 'Reddit',
                    prompt: 'Earn API credits by writing about us on',
                    suffix: '',
                    url: 'https://www.reddit.com/',
                    details: [
                        `Share a post or comment about ${site} in a relevant subreddit — get up to $50 in credits. More upvotes = bigger bonus.`,
                        'AI / MCP: r/mcp, r/ClaudeAI, r/Anthropic, r/OpenAI, r/ollama, r/LocalLLaMA, r/LangChain, r/cursor',
                        'Data / dev: r/datasets, r/webscraping, r/datascience, r/MachineLearning, r/SaaS, r/sideproject',
                        'Ideas: MCP server setup in Claude Desktop, agent/workflow tutorial, dataset walkthrough, API comparison, project showcase',
                    ],
                    cta: `Send your link to <a href="${tgBase}/${tg}">@${tg}</a> on Telegram to claim your reward`,
                    footer: 'Got a following? We offer custom deals for content creators — reach out for personalized terms.',
                },
            ]
        },
        reviewPlatform() {
            const id = this.$state.context.id || 0
            return this.reviewPlatforms[id % this.reviewPlatforms.length]
        },
    },
    methods: {
        checkLogin(context) {
            if (context.loaded && !context.id) {
                window.location.href = '/login'
            }
        },
        handleClickOutside(e) {
            const dropdown = this.$el.querySelector('.nav-item.dropdown')
            if (dropdown && !dropdown.contains(e.target)) {
                this.productsDropdownOpen = false
            }
        }
    }
}
</script>
